import { USER_LOGIN_FETCH_REQUEST, USER_LOGIN_FETCH_SUCCESS, USER_LOGIN_FETCH_FAILURE, USER_LOGIN_EMPTY } from './types';
import baseUrl from '../../url';

const normalizeHomepageVariant = (value) => {
    if (!value) return null;
    const v = String(value).trim();
    return (v === 'control' || v === 'ux') ? v : null;
}

const getHomepageVariant = () => {
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    const params = Object.fromEntries(urlParams);

    const fromParams = params.hv || params.homepage_variant || params.homepageVariant;
    const normalizedParam = normalizeHomepageVariant(fromParams);
    if (normalizedParam) return normalizedParam;

    const cookieMatch = document?.cookie?.match(/(?:^|; )kadro_homepage_variant_raw=([^;]+)/);
    if (cookieMatch && cookieMatch[1]) {
        return normalizeHomepageVariant(decodeURIComponent(cookieMatch[1]));
    }

    return null;
}

const fetchUserLoginRequest = () => {
    return {
        type: USER_LOGIN_FETCH_REQUEST
    }
}

const fetchUserLoginSuccess = user => {
    return {
        type: USER_LOGIN_FETCH_SUCCESS,
        payload: user,
    }
}

const fetchUserLoginFailure = error => {
    return {
        type: USER_LOGIN_FETCH_FAILURE,
        payload: error,
    }
}
const userLoginEmpty = () => {
    return {
        type: USER_LOGIN_EMPTY,
        payload: '',
    }
}

export const postLogin = (phone, query) => {
        return (dispatch) => {
                // console.log("Login Action : ", query);
                if (phone !== '') {
                    dispatch(fetchUserLoginRequest());
                    const homepageVariant = getHomepageVariant();
                    const params = new URLSearchParams(query || "");
                    if (homepageVariant && !params.get('hv')) {
                        params.set('hv', homepageVariant);
                    }
                    const finalQuery = params.toString();

                    fetch(`${baseUrl}/users/login${finalQuery !== "" ? `?${finalQuery}` : ``}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(homepageVariant ? { 'X-Homepage-Variant': homepageVariant } : {})
                },
                body: JSON.stringify({
                    mobile: phone
                })
            })
                .then(response => response.json())
                .then((response) => {
                    dispatch(fetchUserLoginSuccess(response))
                })
                .catch((error) => {
                    dispatch(fetchUserLoginFailure(error.message));
                })
        } else {
            dispatch(userLoginEmpty());
        }
    }
}